import HtmlElement from '../../../Elements/HtmlElement';

/**
 * Jobs Category Switch
 */
const JobsCategorySwitch = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		JOBS_CATEGORY_SWITCH: '.jobs-category-switch',
		TAB: '.jobs-category-tab',
		JOBS_LIST: '.jobs-list',
		JOB: '.jobs-list-item'
	};

	/**
	 * Class Name
	 *
	 * @var { Object }
	 */
	const ClassName = {
		ACTIVE: 'active',
		DISABLED: 'disabled',
		HIDDEN: 'hidden'
	};

	/**
	 * Jobs Category Switch
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class JobsCategorySwitch extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this.tabs = this._getTabs();
			this.jobs = this._getJobs();
			this.$jobsList = this.$element.find(Selector.JOBS_LIST);
			this._activeCategoryUid = undefined;

			this._initialize();
		}

		_initialize() {
			this._initializeActiveState();
			this._bindHandlers();
			this.$jobsList.tablesorter();
		}

		_initializeActiveState() {
			const $firstTab = this.$element.find(Selector.TAB).not(ClassName.DISABLED).first();

			if ($firstTab.length) {
				this._changeCategory($firstTab.data('category'));
			}
		}

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			for (const categoryUid in this.tabs) {
				if (this.tabs.hasOwnProperty(categoryUid)) {
					const $tab = this.tabs[categoryUid];

					$tab.on('click', () => {
						if (this._activeCategoryUid !== categoryUid) {
							this._changeCategory(categoryUid);
						}
					});
				}
			}
		}

		_getTabs() {
			let tabs = {};

			this.$element.find(Selector.TAB).not('.disabled').each((i, el) => {
				const $tab = $(el),
					categoryUid = $tab.data('category');

				tabs[categoryUid] = $tab;
			});

			return tabs;
		}

		_getJobs() {
			let jobs = {};

			this.$element.find(Selector.JOB).each((i, el) => {
				const $job = $(el),
					categoryUid = $job.data('category');

				if (!(categoryUid in jobs)) {
					jobs[categoryUid] = [];
				}

				jobs[categoryUid].push($job);
			});

			return jobs;
		}

		_changeCategory(categoryUid) {
			if (typeof this._activeCategoryUid !== "undefined") {
				const $currentTab = this._getTabOfCategory(this._activeCategoryUid);
				$currentTab.removeClass(ClassName.ACTIVE);
			}

			this._setTabActive(categoryUid);
			this._showCurrentHiddenJobs();
			this._hideJobsNotOfCategory(categoryUid);
			this._activeCategoryUid = categoryUid;
		}

		_getJobsOfCategory(categoryUid) {
			return this.jobs[categoryUid];
		}

		_getTabOfCategory(categoryUid) {
			return this.tabs[categoryUid];
		}

		_setTabActive(categoryUid) {
			const $tab = this._getTabOfCategory(categoryUid);
			$tab.addClass(ClassName.ACTIVE);
		}

		_hideJobsNotOfCategory(categoryUid) {
			const filteredUids = this._getCategoryUidsNotWithUid(categoryUid);

			filteredUids.forEach((uid) => {
				const jobs = this._getJobsOfCategory(uid);
				jobs.forEach(($job) => {
					$job.addClass(ClassName.HIDDEN);
				});
			});
		}

		_showCurrentHiddenJobs() {
			if (typeof this._activeCategoryUid !== "undefined") {
				const categoryUids = this._getCategoryUidsNotWithUid(this._activeCategoryUid);

				categoryUids.forEach((uid) => {
					const jobs = this._getJobsOfCategory(uid);
					jobs.forEach(($job) => {
						$job.removeClass(ClassName.HIDDEN);
					});
				});
			}
		}

		_getCategoryUidsNotWithUid(categoryUid) {
			return Object.keys(this.jobs).filter(key => parseInt(key) !== parseInt(categoryUid))
		}
	}

	return JobsCategorySwitch._getElements(Selector.JOBS_CATEGORY_SWITCH, JobsCategorySwitch);
})();

export default JobsCategorySwitch;
